const UserPoolData = {
    userPoolId: 'eu-central-1_JaqsNWdh0',
    clientId: '176ql0dsldgpqmjb9s0vuk99a0',
    region: 'eu-central-1',
    invokeUrl: 'https://cm9v9y4sah.execute-api.eu-central-1.amazonaws.com/prod',
};

export default UserPoolData;
